export default "__VITE_ASSET__CDIbOhe0__"